import {observer} from "mobx-react-lite";
import {useLeadStore} from "../store/Lead.store";
import React, {useEffect, useState} from "react";
import 'filepond/dist/filepond.min.css';
import './confirmation-new-construction-step.scss'
import useBelfiusTheme from "../theme/ThemeHooks";
import {NotesUploadComponent} from "../components/notes-upload.component";

export const ConfirmationNewConstructionStep = observer( () => {
    const store = useLeadStore();
    const [loading, setLoading] = useState( true );
    let {themeClassName} = useBelfiusTheme();

    useEffect( () => {
        if ( store ) {
            store.fetchConfigurationOptions()
                .then( () => {
                    setLoading( false );
                } )
                .catch( ( err: any ) => {
                    setLoading( false );
                    console.error( "Unexpected error whilst loading events", err )
                } )
        }
    }, [store] );

    const unloadedContent = <div>Loading...</div>;
    const loadedContent = ( themeClassName: string ) => (
        <div className={"row"}>
            <div className="col-md-6">
                <div dangerouslySetInnerHTML={{__html: store.translate( 'leadgeneration.steps.confirmationNewConstructionStep.introduction' )}}/>
            </div>
            <div className={`col-md-6 upload-wrapper ${themeClassName}`}>
                <h3 className={"text-inverted text-uppercase mt-2"}>{store.translate( 'leadgeneration.steps.confirmationNewConstructionStep.notes.title' )}</h3>
                <NotesUploadComponent
                    contentText={store.translate( 'leadgeneration.steps.confirmationNewConstructionStep.notes.upload.text' )}
                    uploadButtonText={store.translate( 'leadgeneration.steps.confirmationNewConstructionStep.notes.upload.button.text' )}
                    theme={themeClassName}
                />
            </div>
        </div>
    );
    return (
        <div>
            {loading && unloadedContent}
            {!loading && <React.Fragment>
                {loadedContent( themeClassName as string )}
            </React.Fragment>}
        </div>
    );
} );
